var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('secition-card', _vm._b({
    staticClass: "fill-height",
    attrs: {
      "title": "지원자 지역"
    }
  }, 'secition-card', {
    loading: _vm.loading
  }, false), [_c('v-data-table', _vm._b({
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "dense": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    'items-per-page': -1,
    'mobile-breakpoint': -1
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }